<template>
  <div>
    <div class="header flex-between">
      <div class="header-text">
        <h1>GIADA Friends券库管理</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-search"
          @click="query"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="el-icon-notebook-2"
          @click="goToGiadaFriendsCashCreate"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.copy"
          icon="el-icon-edit-outline"
          @click="VolumeCopy"
          >复制</el-button
        >
        <el-button
          v-if="jurisdiction.state"
          icon="el-icon-edit-outline"
          @click="StateChange"
          >启用/禁用</el-button
        >
        <el-button
          v-if="jurisdiction.synchronizationn"
          icon="el-icon-edit-outline"
          @click="Synchronization"
          >同步</el-button
        >
        <el-button
          v-if="jurisdiction.modify"
          icon="el-icon-edit-outline"
          @click="ViewUpdate"
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="el-icon-edit-outline"
          @click="Delete"
          >删除</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="el-icon-edit-outline"
          @click="see"
          >查看</el-button
        >
      </div>
    </div>
    <!-- 同步提示框 -->
    <div class="Enabledisable">
      <el-dialog
        width="20%"
        title="同步提示框"
        :visible.sync="EnabledisableFormVisible"
        :close-on-click-modal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">同步</span>此券库?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Enabledisableqd">确 定</el-button>
          <el-button @click="EnabledisableFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <el-card shadow="never">
      <div>
        <el-form label-width="100px" size="small">
          <el-row :gutter="50">
            <el-col :span="8">
              <el-form-item class="redItem" :inline="true" label="券库编号">
                <el-input v-model="page.coupGrpNo"></el-input> </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item label="券库名称">
                <el-input v-model="page.couponsName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="券库后台名称">
                <el-input
                  v-model="page.innerCoupName"
                ></el-input> </el-form-item
            ></el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="8">
              <el-form-item label="券库状态">
                <el-select style="width: 100%" v-model="page.state">
                  <el-option
                    v-for="(item, index) in CouponsState"
                    :key="index"
                    :label="item.lable"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="创建日期">
                <el-date-picker
                  v-model="page.datePicker"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never" class="pagesCard">
      <el-table
        class="table-style"
        border
        :height="PagesIsMore ? 'calc(100vh - 25.5rem)' : 'calc(100vh - 23rem)'"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="SecuritiesList"
        tooltip-effect="dark"
        @select="dialogCheck"
        @selection-change="handleSelectionChange"
        v-el-table-infinite-scroll="PageTouchTheBottom"
        infinite-scroll-disabled="infiniteScrollDisabledIs"
        v-loading="page.Loading"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="coupGrpNo" label="券库编号"> </el-table-column>
        <el-table-column prop="couponsName" label="券库名称">
          <template slot-scope="scope">
            <div
              v-if="jurisdiction.look"
              class="ConponesName"
              @click="OnclickConponesName(scope.row)"
            >
              {{ scope.row.couponsName }}
            </div>
            <div v-else class="ConponesName">
              {{ scope.row.couponsName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="innerCoupName" label="券库后台名称">
        </el-table-column>
        <el-table-column prop="stateText" width="80" label="状态">
        </el-table-column>
        <el-table-column prop="coupValue" width="80" label="券金额">
        </el-table-column>
        <el-table-column prop="createUserName" width="120" label="创始人">
        </el-table-column>
        <el-table-column prop="createTimeStr" width="180" label="创建日期">
        </el-table-column>
        <el-table-column prop="updateUserName" width="120" label="最后修改人">
        </el-table-column>
        <el-table-column prop="updateTimeStr" width="180" label="最后修改日期">
        </el-table-column>
      </el-table>
      <el-alert
        v-if="PagesIsMore"
        title="没有更多数据了!"
        type="warning"
        center
        :closable="false"
      >
      </el-alert>
    </el-card>
  </div>
</template>

<script>
import {
  couponsGroupList,
  couponsGroupDelete,
  TApiLogsyncProcess,
} from "@/api/couponsDepot.js";
import { getcpyNo } from "@/utils/auth";
export default {
  name: "centre",
  data() {
    return {
      EnabledisableFormVisible: false,
      jurisdiction: {
        search: false,
        create: false,
        copy: false,
        state: false,
        modify: false,
        delete: false,
        look: false,
        synchronizationn: false,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      SelectChang: {}, //选择的行
      page: {
        //列表请求参数
        pageNo: 1,
        pageSize: 50,
        pages: 2,
        Loading: true,
        couponsName: "",
        innerCoupName: "",
        coupGrpNo: "",
        createStartDay: "",
        createEndDay: "",
        state: "",
        datePicker: "",
        isGFCoup: true,
      },
      CouponsState: [
        {
          id: "",
          lable: "全部",
        },
        {
          id: "0",
          lable: "已启用",
        },
        {
          id: "1",
          lable: "未启用",
        },
        {
          id: "2",
          lable: "已禁用",
        },
      ],
      SecuritiesList: [], //卷库列表
    };
  },
  created() {
    this.RcouponsGroupList();
    let GiadaFriendsCash = JSON.parse(localStorage.getItem("GiadaFriendsCash"));
    for (let i = 0; i < GiadaFriendsCash.length; i++) {
      if (GiadaFriendsCash[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (GiadaFriendsCash[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }
      if (GiadaFriendsCash[i].menuName == "复制") {
        this.jurisdiction.copy = true;
        continue;
      }
      if (GiadaFriendsCash[i].menuName == "启用/禁用") {
        this.jurisdiction.state = true;
        continue;
      }
      if (GiadaFriendsCash[i].menuName == "同步") {
        this.jurisdiction.synchronizationn = true;
        continue;
      }
      if (GiadaFriendsCash[i].menuName == "修改") {
        this.jurisdiction.modify = true;
        continue;
      }
      if (GiadaFriendsCash[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
      if (GiadaFriendsCash[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
    }
    console.log(GiadaFriendsCash);
  },
  computed: {
    PagesIsMore() {
      return this.page.pageNo >= this.page.pages;
    },
    infiniteScrollDisabledIs() {
      return this.page.Loading || this.PagesIsMore;
    },
  },
  methods: {
    Synchronization() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行同步!",
          type: "warning",
        });
        return false;
      } else {
        if (
          this.SelectChang.stateText == "已启用" ||
          this.SelectChang.stateText == "已禁用"
        ) {
          this.EnabledisableFormVisible = true;
        } else {
          this.$message("未启用记录不能上传!");
        }
      }
    },
    Enabledisableqd() {
      let data = require("qs").stringify({
        id: this.SelectChang.couponsGrpID,
        type: 3,
      });
      TApiLogsyncProcess(data).then((res) => {
        if (res.success == true) {
          this.$message.success("同步成功");
          this.EnabledisableFormVisible = false;
          // this.SelectChang = {};
          this.page.pageNo = 1;
          this.page.Loading = true;
          this.SecuritiesList = [];
          this.RcouponsGroupList();
        } else {
          this.$message.error("同步失败");
        }
      });
    },
    VolumeCopy() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行复制!",
          type: "warning",
        });
        return false;
      }
      this.$store.dispatch("user/USetCouponsSelectChang", this.SelectChang);
      localStorage.setItem(
        "CouponsSelectChang",
        JSON.stringify(this.SelectChang)
      );
      this.$router.push("/GiadaFriendscopy");
    },
    ViewUpdate() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行修改!",
          type: "warning",
        });
        return false;
      }
      this.$store.dispatch("user/USetCouponsSelectChang", this.SelectChang);
      localStorage.setItem(
        "CouponsSelectChang",
        JSON.stringify(this.SelectChang)
      );
      this.$router.push("/GiadaFriendsUpdate");
    },
    Delete() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行状态删除!",
          type: "warning",
        });
        return false;
      }
      this.$confirm("此操作将永久删除该条信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = require("qs").stringify({
            couponsGrpID: this.SelectChang.couponsGrpID,
          });
          couponsGroupDelete(data).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.page.pageNo = 1;
              this.page.Loading = true;
              this.SecuritiesList = [];
              this.RcouponsGroupList();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    StateChange() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行状态修改!",
          type: "warning",
        });
        return false;
      }
      this.$store.dispatch("user/USetCouponsSelectChang", this.SelectChang);
      localStorage.setItem(
        "CouponsSelectChang",
        JSON.stringify(this.SelectChang)
      );
      this.$router.push("/GiadadisableEnable");
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    query() {
      if (this.page.datePicker && this.page.datePicker.length > 0) {
        this.page.createStartDay = this.renderTime(
          this.page.datePicker[0]
        ).substring(0, 10);
        this.page.createEndDay = this.renderTime(
          this.page.datePicker[1]
        ).substring(0, 10);
      } else {
        this.page.createStartDay = "";
        this.page.createEndDay = "";
      }
      this.page.pageNo = 1;
      this.page.Loading = true;
      this.SecuritiesList = [];
      this.RcouponsGroupList();
    },
    OnclickConponesName(row) {
      this.SelectChang = row;
      this.see();
    },
    see() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行查看!",
          type: "warning",
        });
        return false;
      }
      this.$store.dispatch("user/USetCouponsSelectChang", this.SelectChang);
      localStorage.setItem(
        "CouponsSelectChang",
        JSON.stringify(this.SelectChang)
      );
      this.$router.push("/GiadaFriendsSee");
    },
    returnStateText(type) {
      let text = "";
      switch (type) {
        case 0:
          text = "已启用";
          break;
        case 1:
          text = "未启用";
          break;
        case 2:
          text = "已禁用";
          break;
      }
      return text;
    },
    RcouponsGroupList() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        couponsKind: 0,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        coupGrpNo: this.page.coupGrpNo,
        couponsName: this.page.couponsName,
        innerCoupName: this.page.innerCoupName,
        createStartDay: this.page.createStartDay,
        createEndDay: this.page.createEndDay,
        state: this.page.state,
        isGFCoup: this.page.isGFCoup,
      });
      couponsGroupList(data).then((res) => {
        if (res.success) {
          this.page.pages = res.data.pages;
          res.data.list.forEach((item) => {
            item.stateText = this.returnStateText(parseInt(item.state));
          });
          this.SecuritiesList = this.SecuritiesList.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
        this.page.Loading = false;
      });
    },
    PageTouchTheBottom() {
      this.page.Loading = true;
      this.page.pageNo++;
      this.RcouponsGroupList();
    },
    dialogCheck(selection, row) {
      this.$refs.multipleTable.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.SelectChang = row;
        this.$refs.multipleTable.toggleRowSelection(row, true);
      }
    },
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.SelectChang = e[e.length - 1];
      } else {
        this.SelectChang = {};
      }
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    goToGiadaFriendsCashCreate() {
      this.$router.push("/GiadaFriendsCashCreate");
    },
  },
};
</script>
<style lang="scss" scoped>
.pagesCard {
  margin-top: 10px;
}
.ConponesName {
  text-decoration: underline;
  color: #a19b59;
}
.ConponesName:hover {
  cursor: pointer;
}
.header-text {
  height: 50px;
  line-height: 50px;
  color: #76734f;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
}
/deep/.Enabledisable {
  .el-dialog__header,
  .el-message-box__header {
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    height: 44px;
    background: #f3f1dd;
    width: 100%;
    text-align: center;
    color: #666;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .el-dialog__title,
  .el-message-box__title {
    color: #6c6937;
    font-weight: 700;
    font-size: 16px !important;
  }
  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .coverage-release .el-dialog__body {
    padding: 20px;
  }
  .el-button:hover {
    background-color: #b6b388;
  }
  .el-dialog__body {
    padding: 30px 60px;
  }
  .el-tabs__item {
    border: 1px solid #d9d9d9;
    background-color: #fff;
    color: #6c6937;
  }
  .el-dialog__footer {
    height: 60px;
    text-align: center;
    background-color: #f2f2f2;
  }

  .el-tabs__item.is-active {
    color: #6c6937;
    background-color: #f3f1dd;
  }
  .el-form-item__content {
    line-height: 0px;
  }
  .el-textarea__inner {
    // 取消拉伸样式
    resize: none;
  }
}
</style>
